import NewsDetailLayout from '../NewsDetailLayout';
import { kanjiNameData } from '../newsDetailData';

const KanjiNameDetail = () => <NewsDetailLayout data={kanjiNameData} />;
export default KanjiNameDetail;
